import React from 'react';
import PropTypes from 'prop-types';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { StaticDatePicker } from '@mui/x-date-pickers/StaticDatePicker';
import enLocale from 'date-fns/locale/en-US';
import itLocale from 'date-fns/locale/it';
import { injectIntl } from '../../Utils/reactIntlCompat';

const localeMap = {
  en: enLocale,
  it: itLocale,
};

const DbeDatePicker = function DbeDatePicker({
  date,
  onChange,
  inputFormat = 'dd/MM/yyyy',
  staticPicker = false,
  views = null,
  width = '100%',
  ...props
}) {
  const PickerComponent = staticPicker ? StaticDatePicker : DatePicker;
  const componentProps = !staticPicker
    ? {
        inputFormat,
        slotProps: {
          textField: {
            ...props,
            slotProps: { input: { style: { borderRadius: '12px' } } },
          },
        },
        ...props,
      }
    : { ...props };

  const formats = {
    normalDate: inputFormat,
    keyboardDate: inputFormat,
  };

  const formattedDate = (providedDate) => {
    const timestamp = Date.parse(providedDate);

    if (timestamp <= 0 || isNaN(timestamp)) {
      return null;
    }
    return new Date(date);
  };

  return (
    <LocalizationProvider
      dateAdapter={AdapterDateFns}
      adapterLocale={localeMap[navigator.language.substring(0, 2)]}
      dateFormats={formats}
    >
      <PickerComponent
        id="date-picker"
        value={formattedDate(date)}
        onChange={onChange}
        views={views}
        sx={{ width: staticPicker ? 'auto' : width }}
        {...componentProps}
      />
    </LocalizationProvider>
  );
};

DbeDatePicker.propTypes = {
  date: PropTypes.any.isRequired,
  onChange: PropTypes.func.isRequired,
  inputFormat: PropTypes.string,
  staticPicker: PropTypes.bool,
  views: PropTypes.array,
};

export default injectIntl(DbeDatePicker);
